"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseOnFulfilledAsync = exports.onRequestError = exports.requestHeaderOnFulfilledAsync = exports.authCall = void 0;
const axios_1 = __importDefault(require("axios"));
const userInfo_1 = __importDefault(require("../auth/userInfo"));
const application_host_1 = require("../common/application-host");
const firebase_1 = __importStar(require("../auth/firebase"));
const auth_1 = require("../helper/auth");
let wasAuthLoaded;
exports.authCall = axios_1.default.create({
    baseURL: application_host_1.AUTH_API,
    headers: {
        "Content-Type": "application/json",
    },
});
/**
 *
 * @param category
 * @returns
 */
const requestHeaderOnFulfilledAsync = async (config) => {
    const controller = new AbortController();
    const authToken = userInfo_1.default.authToken;
    if (authToken) {
        if (!wasAuthLoaded) {
            console.log('memory token!!!!', authToken);
            const decodedToken = (0, auth_1.decodeUserToken)(authToken);
            console.log('decoded memory token!!!!', authToken);
            const freshToken = decodedToken && decodedToken.exp * 1000 < Date.now()
                ? await firebase_1.default.authStateReady().then(() => { console.log(firebase_1.default, firebase_1.default.currentUser, 'new token objs!!!', (0, firebase_1.getUserToken)()); return (0, firebase_1.getUserToken)(); })
                : authToken;
            config.headers["authorization"] = `Bearer ${freshToken}`;
            userInfo_1.default.authToken = freshToken ?? '';
            wasAuthLoaded = true;
        }
        else {
            config.headers["authorization"] = `Bearer ${authToken}`;
        }
    }
    else if (userInfo_1.default.userId) {
        config.headers["user"] = userInfo_1.default.userId;
    }
    else {
        controller.abort();
    }
    return {
        ...config,
        signal: controller.signal,
    };
};
exports.requestHeaderOnFulfilledAsync = requestHeaderOnFulfilledAsync;
const onRequestError = async (error) => {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        switch (error.response.status) {
            case 401:
                // Unauthorized error - try to refresh the token
                try {
                    const freshToken = await firebase_1.default.authStateReady().then(firebase_1.getRefreshedUserToken);
                    if (freshToken) {
                        userInfo_1.default.authToken = freshToken;
                        // Retry the original request with the new token
                        const originalRequest = error.config;
                        if (originalRequest?.headers) {
                            originalRequest.headers['Authorization'] = `Bearer ${freshToken}`;
                        }
                        if (!originalRequest) {
                            return;
                        }
                        return (0, axios_1.default)(originalRequest);
                    }
                }
                catch (refreshError) {
                    console.error("Token refresh failed:", refreshError);
                    // If token refresh fails, reject the promise and let the app handle the logout
                    return Promise.reject({ ...error, refreshFailed: true });
                }
                break;
            case 403:
                // Forbidden error - user doesn't have necessary permissions
                console.error("Forbidden request:", error.config?.url);
                break;
            case 404:
                // Not Found error
                console.error("Resource not found:", error.config?.url);
                break;
            default:
                // Handle other error status codes
                console.error(`Request failed with status ${error.response.status}:`, error.config?.url);
        }
    }
    else if (error.request) {
        // The request was made but no response was received
        console.error("No response received:", error.request);
    }
    else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error setting up the request:", error.message);
    }
    // If we couldn't handle the error, reject the promise
    return Promise.reject(error);
};
exports.onRequestError = onRequestError;
const responseOnFulfilledAsync = (response) => {
    if (response?.data?.responseObject) {
        return response?.data?.responseObject;
    }
    else if (response?.data?.statusCode === 401 &&
        response?.data?.message === "Invalid JWT token") {
        // Token is invalid, we'll let the next request trigger a refresh
        return Promise.reject(response?.data);
    }
    else {
        return response?.data;
    }
};
exports.responseOnFulfilledAsync = responseOnFulfilledAsync;
exports.authCall.interceptors.request.use(exports.requestHeaderOnFulfilledAsync, exports.onRequestError);
exports.authCall.interceptors.response.use(exports.responseOnFulfilledAsync, (error) => Promise.reject(error));
exports.default = exports.authCall;
